import "core-js/modules/es.array.push.js";
import "/public/css/goods.css";
import "/public/css/oshow.css";
import httpRequest from '@/request/index';
import { ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast, showLoadingToast, closeToast, showConfirmDialog } from 'vant';
import { useRouter } from "vue-router";
import 'vant/es/dialog/style';
export default {
  setup() {
    const store = useStore();
    const orderInfo = ref({});
    const goodsList = ref([]);
    const router = useRouter();
    const oid = ref("");
    const showDel = ref(false);
    const delInfo = () => {
      showConfirmDialog({
        message: '确认删除该订单？',
        theme: 'round-button'
      }).then(() => {
        httpRequest({
          method: "get",
          url: "?file=order&act=del&oid=" + oid.value
        }).then(res => {
          if (res.state == 1) {
            showToast({
              message: res.msg,
              onClose: function () {
                router.push("/order");
              }
            });
          } else {
            showFailToast(res.msg);
          }
        });
      }).catch(() => {});
    };
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      if (router.currentRoute.value.query.oid != "") {
        showLoadingToast({
          message: '加载中',
          forbidClick: true
        });
        oid.value = router.currentRoute.value.query.oid;
        showDel.value = true;
        httpRequest({
          method: "get",
          url: "?file=order&act=show&oid=" + oid.value
        }).then(res => {
          closeToast();
          if (res.state == 1) {
            orderInfo.value = res.info;
            goodsList.value = res.list;
          } else {
            showFailToast(res.msg);
          }
        });
      } else {
        showToast({
          message: "参数错误",
          onClose: function () {
            router.push("/order");
          }
        });
      }
    });
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      orderInfo,
      goodsList,
      delInfo,
      showDel,
      goBack
    };
  }
};